// @flow

import * as StringUtil from 'app/common/lib/StringUtil';
import i18n from 'app/common/lib/i18n';

const composeScheduledSubTitle = (pinCount: number) => {
  const pinCountText =
    pinCount > 0
      ? StringUtil.safeFormat(
          i18n.ngettext(
            '{{ pinCount }} Pin',
            '{{ pinCount }} Pins',
            pinCount,
            'Label for the number of scheduled pins a user owns',
          ),
          { pinCount },
        )
      : i18n._('0 Pins', 'zero scheduled pins');
  const delimiterChar = '‧';
  const visibilityText = i18n._(
    'Only visible to you',
    'The explanatory text that the scheduled pin section is only visible to the profile owner',
  );
  return `${pinCountText} ${delimiterChar} ${visibilityText}`;
};

export default composeScheduledSubTitle;
